import { useDataSelector } from '@uswitch/ev-utils/context/selectors'
import { appendQuery, queryList } from '../../utils/url'

export const FormHiddenFields = ({ action }) => {
  const { query } = useDataSelector(['location'])

  const fields = queryList(appendQuery(action, query))

  return (
    <>
      <For each='param' of={fields} index='i'>
        <input
          key={`param-${i}`}
          type='hidden'
          name={param.param}
          value={decodeURIComponent(param.value)}
        />
      </For>
    </>
  )
}
